import { TAGS } from "../constants";
import { CreateDaysSupply, DaysSupply } from "../types";
import { api } from "./api";

export const daysSupplyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDaysSupply: builder.query<
      DaysSupply,
      { product_id: number; patient_id: number }
    >({
      query: ({ patient_id, product_id }) => ({
        url: `/api/days-supply/${patient_id}/${product_id}`,
        method: "GET",
      }),
      providesTags(_result, _error, arg) {
        return [
          { type: TAGS.DAYS_SUPPLY, id: `${arg.patient_id}-${arg.product_id}` },
        ];
      },
    }),
    getDaysSupplyForPrice: builder.query<
      DaysSupply[],
      { price_id: number; product_id: number }
    >({
      query: ({ price_id, product_id }) => ({
        method: "GET",
        url: `/api/days-supply/price/${price_id}/${product_id}`,
      }),
      providesTags(_result, _error, arg) {
        return [
          { type: TAGS.DAYS_SUPPLY, id: `${arg.product_id}-${arg.price_id}` },
        ];
      },
    }),
    createDaysSupply: builder.mutation<DaysSupply, CreateDaysSupply>({
      query: (body) => ({
        method: "POST",
        url: `/api/days-supply`,
        body,
      }),
      invalidatesTags: [TAGS.DAYS_SUPPLY],
    }),
  }),
});

export const {
  useGetDaysSupplyQuery,
  useGetDaysSupplyForPriceQuery,
  useCreateDaysSupplyMutation,
} = daysSupplyApi;
